import React, { useState, useContext } from "react";
import AppContext from '../api/AppContext';
import { FaMapMarkerAlt, FaUpload, FaCheck, FaTimes, FaUser, FaPhone, FaBriefcase, FaEnvelope, FaEdit } from 'react-icons/fa';

const APP_URL = 'https://app.olympicbarbacena.com.br';

export default function Perfil() {
  const [showComprovanteModal, setShowComprovanteModal] = useState(false);
  const [showFotoModal, setShowFotoModal] = useState(false);
  const [showAddressUpdateModal, setShowAddressUpdateModal] = useState(false);
  const [showDadosPessoaisModal, setShowDadosPessoaisModal] = useState(false);
  const [comprovante, setComprovante] = useState(null);
  const [foto, setFoto] = useState(null);
  const [newAddress, setNewAddress] = useState({
    logradouro: '',
    numero: '',
    bairro: '',
    cidade: '',
    uf: '',
    cep: '',
    complemento: ''
  });
  const [comprovanteUrl, setComprovanteUrl] = useState('');
  const [comprovanteFile, setComprovanteFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [addressUpdateLoading, setAddressUpdateLoading] = useState(false);

  const [newDadosPessoais, setNewDadosPessoais] = useState({
    email: '',
    estadoCivil: '',
    profissao: '',
    fone1: '',
    fone2: '',
    fone3: ''
  });
  const [comprovanteEstadoCivilUrl, setComprovanteEstadoCivilUrl] = useState('');
  const [comprovanteEstadoCivilFile, setComprovanteEstadoCivilFile] = useState(null);
  const [dadosPessoaisLoading, setDadosPessoaisLoading] = useState(false);

  const { user, logout, token } = useContext(AppContext);
  const dadosAssociado = user?.dadosAssociado;
  const addressStatus = user?.enderecoVerification?.status;
  const dadosPessoaisStatus = user?.dadosPessoaisVerification?.status;
  
  const isAdimplente = dadosAssociado?.adimplente === true || dadosAssociado?.adimplente === 'true';
  const isInadimplente = dadosAssociado?.adimplente === false || dadosAssociado?.adimplente === 'false';

  const formatCPF = (cpf) => {
    if (!cpf) return '';
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  const formatTelefone = (telefone) => {
    if (!telefone) return '';
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  };

  const handleLogout = () => {
    if (logout) {
      logout();
    } else {
      window.location.href = '/login';
    }
  };

  return (
    <div style={{ ...styles.container, backgroundColor: isInadimplente ? '#fff5f5' : styles.container.backgroundColor }}>
      <div style={{ ...styles.card, backgroundColor: isInadimplente ? '#fff0f0' : styles.card.backgroundColor, border: isInadimplente ? '2px solid #e53935' : 'none' }}>
        {/* Cabeçalho com título e botão de logout */}
          <div style={styles.header}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              {dadosAssociado?.foto || dadosAssociado?.titular?.foto ? (
                <img src={dadosAssociado.foto || dadosAssociado.titular.foto} alt="Foto" style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #1A3B7D' }} />
              ) : (
                <div style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <FaUser size={30} color="#666" />
                </div>
              )}
              <div>
                <h2 style={styles.title}>Perfil</h2>
                {isInadimplente && (
                  <span style={{
                    display: 'inline-block',
                    marginTop: '4px',
                    padding: '4px 12px',
                    backgroundColor: '#e53935',
                    color: 'white',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '700',
                    fontFamily: 'Montserrat, sans-serif'
                  }}>
                    ⚠️ Inadimplente
                  </span>
                )}
                {isAdimplente && (
                  <span style={{
                    display: 'inline-block',
                    marginTop: '4px',
                    padding: '4px 12px',
                    backgroundColor: '#2e7d32',
                    color: 'white',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '700',
                    fontFamily: 'Montserrat, sans-serif'
                  }}>
                    ✅ Adimplente
                  </span>
                )}
              </div>
            </div>
            <button style={styles.logoutButton} onClick={handleLogout}>
              Sair
            </button>
          </div>

        {/* Dados Pessoais */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Dados Pessoais</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Nome completo</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.NOME || dadosAssociado?.titular?.nome || user?.name || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.EMAIL || dadosAssociado?.titular?.email || user?.email || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>CPF</label>
            <input 
              style={styles.input} 
              value={formatCPF(dadosAssociado?.CPF || dadosAssociado?.titular?.cpf || user?.cpf)} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Data de Nascimento</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.NASCIMENTO ? new Date(dadosAssociado.NASCIMENTO).toLocaleDateString('pt-BR') : 
                    dadosAssociado?.titular?.nascimento ? new Date(dadosAssociado.titular.nascimento).toLocaleDateString('pt-BR') : ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Sexo</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.SEXO ? (dadosAssociado.SEXO.trim() === 'M' ? 'Masculino' : 'Feminino') : ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Estado Civil</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.ESTADOCIVIL || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Profissão</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.PROFISSAO || ''} 
              readOnly 
            />
          </div>

          <button
            onClick={() => setShowDadosPessoaisModal(true)}
            style={{
              marginTop: '12px',
              padding: '10px 20px',
              backgroundColor: '#2563EB',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <FaEdit size={14} /> Atualizar Dados Pessoais
          </button>

          {dadosPessoaisStatus === 'rejected' && (
            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: '#FEF3C7', borderRadius: '8px', border: '1px solid #F59E0B' }}>
              <p style={{ margin: 0, fontSize: '14px', color: '#92400E' }}>
                ⚠️ Seus dados foram rejeitados. Atualize e envie novamente.
              </p>
            </div>
          )}

          {dadosPessoaisStatus === 'pending' && (
            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: '#DBEAFE', borderRadius: '8px', border: '1px solid #3B82F6' }}>
              <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', color: '#1E40AF' }}>
                ⏳ Seus dados estão em análise. Aguarde a aprovação.
              </p>
            </div>
          )}

          {dadosPessoaisStatus === 'approved' && (
            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: '#D1FAE5', borderRadius: '8px', border: '1px solid #10B981' }}>
              <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', color: '#065F46' }}>
                ✅ Seus dados foram aprovados.
              </p>
            </div>
)}
        </div>

        {/* Contatos */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Contatos</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Telefone 1</label>
            <input 
              style={styles.input} 
              value={formatTelefone(dadosAssociado?.FONE1)} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Telefone 2</label>
            <input 
              style={styles.input} 
              value={formatTelefone(dadosAssociado?.FONE2)} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Telefone 3</label>
            <input 
              style={styles.input} 
              value={formatTelefone(dadosAssociado?.FONE3)} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Facebook</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.FACEBOOK || ''} 
              readOnly 
            />
          </div>
        </div>

        {/* Endereço */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Endereço</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>CEP</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.CEP || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Logradouro</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.LOGRADOURO || ''} 
              readOnly 
            />
          </div>

          <div style={styles.row}>
            <div style={{...styles.formGroup, flex: 1}}>
              <label style={styles.label}>Número</label>
              <input 
                style={styles.input} 
                value={dadosAssociado?.NUMERO || ''} 
                readOnly 
              />
            </div>
            <div style={{...styles.formGroup, flex: 2}}>
              <label style={styles.label}>Complemento</label>
              <input 
                style={styles.input} 
                value={dadosAssociado?.COMPLEMENTO || ''} 
                readOnly 
              />
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Bairro</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.BAIRRO || ''} 
              readOnly 
            />
          </div>

          <div style={styles.row}>
            <div style={{...styles.formGroup, flex: 2}}>
              <label style={styles.label}>Cidade</label>
              <input 
                style={styles.input} 
                value={dadosAssociado?.CIDADE || ''} 
                readOnly 
              />
            </div>
            <div style={{...styles.formGroup, flex: 1}}>
              <label style={styles.label}>UF</label>
              <input 
                style={styles.input} 
                value={dadosAssociado?.UF || ''} 
                readOnly 
              />
            </div>
          </div>

        </div>

        {addressStatus === 'rejected' && (
          <div style={{ marginTop: '16px', padding: '16px', backgroundColor: '#FEF3C7', borderRadius: '8px', border: '1px solid #F59E0B' }}>
            <p style={{ margin: '0 0 12px', fontSize: '14px', fontWeight: '600', color: '#92400E' }}>
              ⚠️ Seu endereço foi rejeitado. Por favor, atualize para submeter novamente.
            </p>
          </div>
        )}

        {addressStatus === 'pending' && (
          <div style={{ marginTop: '16px', padding: '16px', backgroundColor: '#DBEAFE', borderRadius: '8px', border: '1px solid #3B82F6' }}>
            <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', color: '#1E40AF' }}>
              ⏳ Seu endereço está em análise. Aguarde a aprovação do admin.
            </p>
          </div>
        )}

        {addressStatus === 'approved' && (
          <div style={{ marginTop: '16px', padding: '16px', backgroundColor: '#D1FAE5', borderRadius: '8px', border: '1px solid #10B981' }}>
            <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', color: '#065F46' }}>
              ✅ Seu endereço foi aprovado.
            </p>
          </div>
        )}

        <button
          onClick={() => setShowAddressUpdateModal(true)}
          style={{
            marginTop: '16px',
            padding: '10px 20px',
            backgroundColor: '#2563EB',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
<FaMapMarkerAlt size={14} /> Atualizar Endereço
        </button>

        {/* Dados do Associado */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Dados do Associado</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Número do Título</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.numero || dadosAssociado?.TITULO || user?.numeroTitulo || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Situação</label>
            <div style={{
              ...styles.input,
              display: 'flex',
              alignItems: 'center',
              fontWeight: '700',
              color: isInadimplente ? '#c62828' : '#2e7d32',
              backgroundColor: isInadimplente ? '#ffebee' : '#e8f5e9'
            }}>
              {isInadimplente ? '⚠️ Inadimplente' : isAdimplente ? '✅ Adimplente' : '—'}
            </div>
          </div>

          {/* <div style={styles.formGroup}>
            <label style={styles.label}>Situação</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.adimplente ? 'Adimplente' : 'Inadimplente'} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Status</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.ATIVO?.trim() === 'S' ? 'Ativo' : 'Inativo'} 
              readOnly 
            />
          </div> */}

          <div style={styles.formGroup}>
            <label style={styles.label}>Data de Inclusão</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.INCLUSAO ? new Date(dadosAssociado.INCLUSAO).toLocaleDateString('pt-BR') : ''} 
              readOnly 
            />
          </div>
        </div>

        {/* Botões de ação */}
        {/* <button style={styles.button} onClick={() => setShowComprovanteModal(true)}>
          <span style={styles.icon}>🖼️</span> Alterar comprovante de residência
        </button>

        <button style={styles.button} onClick={() => setShowFotoModal(true)}>
          <span style={styles.icon}>📷</span> Alterar foto
        </button> */}
      </div>

      {/* Modais */}
      {showComprovanteModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>Enviar comprovante de residência</h3>
            <input
              type="file"
              onChange={(e) => setComprovante(e.target.files[0])}
              style={styles.fileInput}
            />
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowComprovanteModal(false)}>
                Cancelar
              </button>
              <button
                style={styles.saveBtn}
                onClick={() => {
                  setShowComprovanteModal(false);
                  alert("Comprovante anexado com sucesso!");
                }}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}

      {showFotoModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>Alterar foto</h3>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setFoto(e.target.files[0])}
              style={styles.fileInput}
            />
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowFotoModal(false)}>
                Cancelar
              </button>
              <button
                style={styles.saveBtn}
                onClick={() => {
                  setShowFotoModal(false);
                  alert("Foto alterada com sucesso!");
                }}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Atualização de Endereço */}
      {showAddressUpdateModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 9999, padding: '20px'
        }} onClick={() => setShowAddressUpdateModal(false)}>
          <div style={{
            backgroundColor: 'white', borderRadius: '16px', width: '100%', maxWidth: '500px',
            maxHeight: '90vh', overflow: 'auto', padding: '24px'
          }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 20px', color: '#1A3B7D', fontSize: '18px', fontWeight: '600' }}>
              <FaMapMarkerAlt style={{ marginRight: '8px' }} />
              Atualizar Endereço
            </h3>

            <div style={styles.formGroup}>
              <label style={styles.label}>Rua/Logradouro:</label>
              <input
                style={styles.input}
                value={newAddress.logradouro}
                onChange={(e) => setNewAddress({ ...newAddress, logradouro: e.target.value })}
                placeholder="Rua/Avenida"
              />
            </div>

            <div style={styles.row}>
              <div style={{ ...styles.formGroup, flex: 1 }}>
                <label style={styles.label}>Número:</label>
                <input
                  style={styles.input}
                  value={newAddress.numero}
                  onChange={(e) => setNewAddress({ ...newAddress, numero: e.target.value })}
                  placeholder="Número"
                />
              </div>
              <div style={{ ...styles.formGroup, flex: 2 }}>
                <label style={styles.label}>Complemento:</label>
                <input
                  style={styles.input}
                  value={newAddress.complemento}
                  onChange={(e) => setNewAddress({ ...newAddress, complemento: e.target.value })}
                  placeholder="Complemento"
                />
              </div>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Bairro:</label>
              <input
                style={styles.input}
                value={newAddress.bairro}
                onChange={(e) => setNewAddress({ ...newAddress, bairro: e.target.value })}
                placeholder="Bairro"
              />
            </div>

            <div style={styles.row}>
              <div style={{ ...styles.formGroup, flex: 2 }}>
                <label style={styles.label}>Cidade:</label>
                <input
                  style={styles.input}
                  value={newAddress.cidade}
                  onChange={(e) => setNewAddress({ ...newAddress, cidade: e.target.value })}
                  placeholder="Cidade"
                />
              </div>
              <div style={{ ...styles.formGroup, flex: 1 }}>
                <label style={styles.label}>UF:</label>
                <input
                  style={styles.input}
                  value={newAddress.uf}
                  onChange={(e) => setNewAddress({ ...newAddress, uf: e.target.value })}
                  placeholder="UF"
                  maxLength={2}
                />
              </div>
              <div style={{ ...styles.formGroup, flex: 1 }}>
                <label style={styles.label}>CEP:</label>
                <input
                  style={styles.input}
                  value={newAddress.cep}
                  onChange={(e) => setNewAddress({ ...newAddress, cep: e.target.value })}
                  placeholder="CEP"
                />
              </div>
            </div>

            <div style={{ marginTop: '16px' }}>
              <label style={styles.label}>Comprovante de Residência:</label>
              <input
                type="file"
                accept="image/jpeg,image/jpg,image/png,image/gif,image/webp,application/pdf"
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  if (file.size > 10 * 1024 * 1024) {
                    alert('O arquivo deve ter no máximo 10MB');
                    return;
                  }
                  setComprovanteFile(file);
                  setUploading(true);
                  try {
                    const formData = new FormData();
                    formData.append('file', file);
                    const res = await fetch(`${APP_URL}/api/upload/comprovante-endereco`, {
                      method: 'POST',
                      body: formData
                    });
                    const data = await res.json();
                    if (res.ok) {
                      setComprovanteUrl(data.url);
                    } else {
                      alert(data.error || 'Erro ao enviar arquivo');
                    }
                  } catch (err) {
                    alert('Erro de conexão');
                  } finally {
                    setUploading(false);
                  }
                }}
                style={{ marginTop: '8px' }}
              />
              {comprovanteUrl && (
                <p style={{ color: '#10B981', fontSize: '13px', marginTop: '8px' }}>✓ Comprovante enviado</p>
              )}
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowAddressUpdateModal(false)}
                style={{ padding: '10px 20px', backgroundColor: '#6B7280', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
              >
                Cancelar
              </button>
              <button
                onClick={async () => {
                  if (!newAddress.logradouro || !newAddress.numero || !newAddress.bairro || !newAddress.cidade || !newAddress.uf || !newAddress.cep) {
                    alert('Preencha todos os campos do endereço');
                    return;
                  }
                  if (!comprovanteUrl) {
                    alert('Envie o comprovante de residência');
                    return;
                  }
                  setAddressUpdateLoading(true);
                  try {
                    const res = await fetch(`${APP_URL}/api/auth/update-address`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ newAddress, comprovanteUrl: comprovanteUrl })
                    });
                    const data = await res.json();
                    if (res.ok) {
                      alert(data.message);
                      setShowAddressUpdateModal(false);
                    } else {
                      alert(data.message || 'Erro ao atualizar endereço');
                    }
                  } catch (err) {
                    alert('Erro de conexão');
                  } finally {
                    setAddressUpdateLoading(false);
                  }
                }}
                disabled={addressUpdateLoading || uploading}
                style={{
                  padding: '10px 20px', backgroundColor: '#2563EB', color: 'white',
                  border: 'none', borderRadius: '6px', cursor: addressUpdateLoading || uploading ? 'not-allowed' : 'pointer',
                  opacity: addressUpdateLoading || uploading ? 0.7 : 1
                }}
              >
                {addressUpdateLoading ? 'Enviando...' : 'Enviar para Validação'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Atualização de Dados Pessoais */}
      {showDadosPessoaisModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 9999, padding: '20px'
        }} onClick={() => setShowDadosPessoaisModal(false)}>
          <div style={{
            backgroundColor: 'white', borderRadius: '16px', width: '100%', maxWidth: '500px',
            maxHeight: '90vh', overflow: 'auto', padding: '24px'
          }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 20px', color: '#1A3B7D', fontSize: '18px', fontWeight: '600' }}>
              <FaUser style={{ marginRight: '8px' }} />
              Atualizar Dados Pessoais
            </h3>

            <p style={{ fontSize: '13px', color: '#666', marginBottom: '16px' }}>
              Preencha apenas os campos que deseja atualizar. Estado civil requer comprovante.
            </p>

            <div style={styles.formGroup}>
              <label style={styles.label}><FaEnvelope style={{ marginRight: '6px' }} />Email:</label>
              <input
                style={styles.input}
                value={newDadosPessoais.email}
                onChange={(e) => setNewDadosPessoais({ ...newDadosPessoais, email: e.target.value })}
                placeholder={dadosAssociado?.EMAIL || 'Seu email'}
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}><FaBriefcase style={{ marginRight: '6px' }} />Profissão:</label>
              <input
                style={styles.input}
                value={newDadosPessoais.profissao}
                onChange={(e) => setNewDadosPessoais({ ...newDadosPessoais, profissao: e.target.value })}
                placeholder={dadosAssociado?.PROFISSAO || 'Sua profissão'}
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}><FaUser style={{ marginRight: '6px' }} />Estado Civil:</label>
              <select
                style={styles.input}
                value={newDadosPessoais.estadoCivil}
                onChange={(e) => setNewDadosPessoais({ ...newDadosPessoais, estadoCivil: e.target.value })}
              >
                <option value="">Selecione...</option>
                <option value="SOLTEIRO">Solteiro</option>
                <option value="CASADO">Casado</option>
                <option value="DIVORCIADO">Divorciado</option>
                <option value="VIÚVO">Viúvo</option>
                <option value="UNIÃO ESTÁVEL">União Estável</option>
              </select>
              {newDadosPessoais.estadoCivil && (
                <div style={{ marginTop: '12px' }}>
                  <label style={styles.label}>Comprovante (casamento/divórcio):</label>
                  <input
                    type="file"
                    accept="image/jpeg,image/jpg,image/png,image/gif,image/webp,application/pdf"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (!file) return;
                      if (file.size > 10 * 1024 * 1024) {
                        alert('O arquivo deve ter no máximo 10MB');
                        return;
                      }
                      setComprovanteEstadoCivilFile(file);
                      setDadosPessoaisLoading(true);
                      try {
                        const formData = new FormData();
                        formData.append('file', file);
                        const res = await fetch(`${APP_URL}/api/upload/comprovante-endereco`, {
                          method: 'POST',
                          body: formData
                        });
                        const data = await res.json();
                        if (res.ok) {
                          setComprovanteEstadoCivilUrl(data.url);
                        } else {
                          alert(data.error || 'Erro ao enviar arquivo');
                        }
                      } catch (err) {
                        alert('Erro de conexão');
                      } finally {
                        setDadosPessoaisLoading(false);
                      }
                    }}
                    style={{ marginTop: '8px' }}
                  />
                  {comprovanteEstadoCivilUrl && (
                    <p style={{ color: '#10B981', fontSize: '13px', marginTop: '8px' }}>✓ Comprovante enviado</p>
                  )}
                </div>
              )}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}><FaPhone style={{ marginRight: '6px' }} />Telefone 1:</label>
              <input
                style={styles.input}
                value={newDadosPessoais.fone1}
                onChange={(e) => setNewDadosPessoais({ ...newDadosPessoais, fone1: e.target.value.replace(/\D/g, '').slice(0, 11) })}
                placeholder={formatTelefone(dadosAssociado?.FONE1) || 'Seu telefone'}
                maxLength={11}
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}><FaPhone style={{ marginRight: '6px' }} />Telefone 2:</label>
              <input
                style={styles.input}
                value={newDadosPessoais.fone2}
                onChange={(e) => setNewDadosPessoais({ ...newDadosPessoais, fone2: e.target.value.replace(/\D/g, '').slice(0, 11) })}
                placeholder={formatTelefone(dadosAssociado?.FONE2) || 'Outro telefone'}
                maxLength={11}
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}><FaPhone style={{ marginRight: '6px' }} />Telefone 3:</label>
              <input
                style={styles.input}
                value={newDadosPessoais.fone3}
                onChange={(e) => setNewDadosPessoais({ ...newDadosPessoais, fone3: e.target.value.replace(/\D/g, '').slice(0, 11) })}
                placeholder={formatTelefone(dadosAssociado?.FONE3) || 'Outro telefone'}
                maxLength={11}
              />
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowDadosPessoaisModal(false);
                  setNewDadosPessoais({ email: '', estadoCivil: '', profissao: '', fone1: '', fone2: '', fone3: '' });
                  setComprovanteEstadoCivilUrl('');
                }}
                style={{ padding: '10px 20px', backgroundColor: '#6B7280', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
              >
                Cancelar
              </button>
              <button
                onClick={async () => {
                  const hasAnyData = newDadosPessoais.email || newDadosPessoais.profissao || newDadosPessoais.fone1 || newDadosPessoais.fone2 || newDadosPessoais.fone3 || newDadosPessoais.estadoCivil;
                  if (!hasAnyData) {
                    alert('Preencha pelo menos um dado para atualizar');
                    return;
                  }
                  if (newDadosPessoais.estadoCivil && !comprovanteEstadoCivilUrl) {
                    alert('Para atualizar estado civil, envie o comprovante');
                    return;
                  }
                  setDadosPessoaisLoading(true);
                  try {
                    const res = await fetch(`${APP_URL}/api/auth/update-dados-pessoais`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ 
                        ...newDadosPessoais, 
                        comprovanteUrl: newDadosPessoais.estadoCivil ? comprovanteEstadoCivilUrl : undefined 
                      })
                    });
                    const data = await res.json();
                    if (res.ok) {
                      alert(data.message);
                      setShowDadosPessoaisModal(false);
                      setNewDadosPessoais({ email: '', estadoCivil: '', profissao: '', fone1: '', fone2: '', fone3: '' });
                      setComprovanteEstadoCivilUrl('');
                    } else {
                      alert(data.message || 'Erro ao atualizar dados');
                    }
                  } catch (err) {
                    alert('Erro de conexão');
                  } finally {
                    setDadosPessoaisLoading(false);
                  }
                }}
                disabled={dadosPessoaisLoading}
                style={{
                  padding: '10px 20px', backgroundColor: '#2563EB', color: 'white',
                  border: 'none', borderRadius: '6px', cursor: dadosPessoaisLoading ? 'not-allowed' : 'pointer',
                  opacity: dadosPessoaisLoading ? 0.7 : 1
                }}
              >
                {dadosPessoaisLoading ? 'Enviando...' : 'Enviar para Validação'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ESTILOS ATUALIZADOS
const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    backgroundColor: "#eef1ff",
    padding: "20px",
  },
  card: {
    width: "100%",
    maxWidth: "500px",
    backgroundColor: "#f2f4ff",
    borderRadius: "20px",
    padding: "30px 20px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    marginBottom: "75px",
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '25px',
  },
  title: {
    color: "#0a2c6d",
    fontWeight: "700",
    fontSize: '24px',
    margin: 0,
  },
logoutButton: {
  backgroundColor: '#f44336',
  color: 'white',
  border: 'none',
  borderRadius: '20px',
  padding: '10px 16px',
  fontSize: '14px',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: '0.3s',
  outline: 'none',
},
  section: {
    marginBottom: "25px",
    paddingBottom: "15px",
    borderBottom: "1px solid #e0e0e0",
  },
  sectionTitle: {
    color: "#0a2c6d",
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "15px",
  },
  formGroup: {
    marginBottom: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontSize: "14px",
    color: "#333",
    fontWeight: "500",
  },
  input: {
    width: "100%",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "15px",
    outline: "none",
    fontSize: "14px",
    backgroundColor: "#fff",
    color: "#333",
  },
  row: {
    display: "flex",
    gap: "8px",
  },
  button: {
    width: "100%",
    backgroundColor: "white",
    border: "1px solid #ddd",
    borderRadius: "15px",
    padding: "12px",
    marginTop: "12px",
    fontSize: "15px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    transition: "0.3s",
  },
  icon: {
    backgroundColor: "#2e7df6",
    borderRadius: "50%",
    color: "white",
    padding: "8px",
    fontSize: "18px",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    padding: "25px",
    borderRadius: "15px",
    width: "90%",
    maxWidth: "400px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
    textAlign: "center",
  },
  fileInput: {
    marginTop: "10px",
    marginBottom: "20px",
  },
  modalButtons: {
    display: "flex",
    justifyContent: "space-between",
  },
  cancelBtn: {
    backgroundColor: "#ccc",
    border: "none",
    borderRadius: "10px",
    padding: "10px 20px",
    cursor: "pointer",
  },
  saveBtn: {
    backgroundColor: "#2e7df6",
    border: "none",
    borderRadius: "10px",
    color: "white",
    padding: "10px 20px",
    cursor: "pointer",
  },
};